import { createFileRoute, Outlet } from "@tanstack/react-router";
import { guardRoute } from "@/lib/policy/route-guard";

export const Route = createFileRoute("/_authenticated/_financials/monthly-responsibility")({
  beforeLoad: ({ context }) => guardRoute(context.me, "monthly-responsibility"),
  component: Outlet,
});
